/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, IconButton, Typography, CircularProgress, LinearProgress, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import { Clear } from '@material-ui/icons'

import { Skeleton } from '@material-ui/lab'

import Actions from '../../../../../fluid/Actions/ActionFactory'

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})
class FieldSimilarity extends Component {
    state = {
        stats : null,
        stats_loading : false,
        stats_load_error : false
    }

    componentDidMount () {
        this.getStats()
    }

    componentDidUpdate (prevProps) {
        if (prevProps.fields !== this.props.fields) {
            this.getStats()
        }
    }

    getStats = () => {
        this.setState({...this.state, stats_loading : true, stats_load_error : false, stats : null}, () => {
            Actions('http_request', {
                url: "/sainapse/ifc/similarity_for_fields",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                    field1 : this.props.fields[0],
                    field2 : this.props.fields[1]
                }
            }).then(res => {
                console.log("IFC :: Field Similarity Result : ", res)
                this.setState({...this.state, stats_loading : false, stats_load_error : false, stats: res.data.result.Result})
            })
        })
    }

    renderStatsArea = () => {
        return (
            <Fragment>
                <div style = {{width : '100%', height : '108px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    {this.renderStats()}
                </div>
                <div style = {{width : '100%', flexGrow : 1, backgroundColor : '#F5F5F5'}}>
                    {this.renderCommonValues()}
                </div>
            </Fragment>
        )
    }

    renderStats = () => {
        if (this.state.stats) {
            return (
                <div
                    style = {{width : '100%', padding : '10px'}}
                >
                    <div style = {{marginBottom : '10px'}}>
                        <div style = {{width : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'flex-end'}}>
                            <Typography style = {{flexGrow : 1}} variant = 'caption'>Name Similarity</Typography>
                            <Typography style = {{fontWeight : 500}} variant = 'caption' color = 'primary'>{this.state.stats.name_similarity.toFixed(2)}</Typography>
                        </div>
                        <LinearProgress variant = 'determinate' color = 'primary' value = {this.state.stats.name_similarity * 100}/>
                    </div>
                    <div style = {{marginBottom : '10px'}}>
                        <div style = {{width : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'flex-end'}}>
                            <Typography style = {{flexGrow : 1}} variant = 'caption'>Value Similarity</Typography>
                            <Typography style = {{fontWeight : 500}} variant = 'caption' color = 'primary'>{this.state.stats.value_similarity.toFixed(2)}</Typography>
                        </div>
                        <LinearProgress variant = 'determinate' color = 'primary' value = {this.state.stats.value_similarity * 100}/>
                    </div>
                    <div>
                        <div style = {{width : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'flex-end'}}>
                            <Typography style = {{flexGrow : 1}} variant = 'caption'>Percentage of Common Values</Typography>
                            <Typography style = {{fontWeight : 500}} variant = 'caption' color = 'primary'>{(this.state.stats.IoU * 100).toFixed(2) + '%'}</Typography>
                        </div>
                        <LinearProgress variant = 'determinate' color = 'primary' value = {this.state.stats.IoU * 100}/>
                    </div>
                </div>
            )
        } else {
            // if (this.state.stats_loading) {
            //     return (
            //         <div style = {{width : '100%', padding : '10px'}}>
            //             <Skeleton style = {{marginBottom : '10px'}} variant = 'rect' />
            //             <Skeleton style = {{marginBottom : '10px'}} variant = 'rect' />
            //             <Skeleton style = {{marginBottom : '10px'}} variant = 'rect' />
            //         </div>
            //     )
            // }
        }
    }

    renderCommonValues = () => {
        if (this.state.stats) {
            return (
                <div style = {{padding : '10px'}}>
                    <Typography display = 'block' variant = 'subtitle2'>{"Common Values (" + this.state.stats.common_elements.length + ")"}</Typography>
                    <TableContainer
                        style = {{maxHeight : '55vh'}}
                    >
                        <Table
                            style = {{
                                borderCollapse : 'separate',
                                borderSpacing : '0px 7px',
                                marginRight : '10px',
                            }}
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        style = {{
                                            color : '#707070',
                                            backgroundColor : '#F5F5F5',
                                            fontSize : 11,
                                            border : 'none'
                                        }}
                                        padding = 'none' 
                                        size = 'small'
                                        align = 'center'
                                    >
                                        Value
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.stats.common_elements.map(val => {
                                    return (
                                        <TableRow
                                            style = {{
                                                backgroundColor : '#FFFFFF',
                                                padding : '10px',
                                                boxShadow : '1px 2px 12px -9px rgba(0,0,0,0.49)',
                                                width : '90%'
                                            }}
                                        >
                                            <TableCell
                                                style = {{ 
                                                    border: 'none',
                                                    fontSize : 12
                                                }}
                                                align = 'center'
                                            >{val}</TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            )
        } else {
            if (this.state.stats_loading) {
                return (
                    <div style = {{width : '100%', height : '100%', padding : '10px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <CircularProgress variant = 'indeterminate' color = 'primary'/>
                    </div>
                )
            }
        }
    }


    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper 
                    square
                    elevation = {10}
                    style = {{
                        position : 'fixed',
                        top : '200px',
                        left : 'calc('+ (25 * this.props.field_similarity_col_indices[1]) + 'vw - 12vw)',
                        width : '24vw',
                        height : 'calc(100vh - 220px)',
                        zIndex : 12,
                        display : 'flex',
                        flexDirection : 'column'
                    }}
                >
                    <Paper 
                        square 
                        elevation = {0}
                        style = {{
                            width : '100%', 
                            height : '40px', 
                            padding : '10px',
                            display : 'flex',
                            flexDirection : 'row',
                            alignItems : 'center',
                            // borderBottom : '1px solid rgba(0,0,0,0.12)'
                        }}
                    >
                        <div style = {{flexGrow : 1}}>
                            <Typography display = 'inline' variant = 'subtitle2'>{this.props.field_display_name + "Similarity"}</Typography>
                            {/* <Typography display = 'inline' variant = 'caption' >Evaluating {this.props.fields[0]} and {this.props.fields[1]}</Typography> */}
                        </div>
                        <div>
                            <IconButton 
                                size = 'small' 
                                color = 'secondary'
                                onClick = {() => this.props.close_field_similarity()}
                            >
                                <Clear fontSize = 'inherit'/>
                            </IconButton>
                        </div>
                    </Paper>
                    {this.renderStatsArea()}
                </Paper>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(FieldSimilarity);